import { motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { AWARDS } from "../data/content";

export const Awards = () => (
  <section
    className="relative border-t border-white/5 bg-[#101010]"
    data-testid="awards-section"
  >
    <div className="mx-auto grid max-w-[1400px] gap-16 px-6 py-28 lg:grid-cols-12 lg:px-10 lg:py-40">
      <div className="lg:col-span-5">
        <Reveal>
          <Overline>Recognition</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-serif text-4xl tracking-tight text-white sm:text-5xl">
            Awards
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-md text-base leading-relaxed text-zinc-400">
            Independent recognition across international film festivals — for
            direction and short-form storytelling.
          </p>
        </Reveal>
      </div>

      <div className="lg:col-span-6 lg:col-start-7">
        <div className="border-t border-white/10">
          {AWARDS.map((a, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
              className="group flex items-baseline gap-6 border-b border-white/10 py-6"
              data-testid={`award-${i}`}
            >
              <span className="w-16 shrink-0 font-serif text-xl italic text-gold/80">
                {a.year}
              </span>
              <div>
                <h3 className="font-serif text-2xl text-white transition-colors duration-300 group-hover:text-gold">
                  {a.title}
                </h3>
                <p className="mt-1 text-sm text-zinc-500">{a.org}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
